const apps = process.env.APP_CONFIG

export function getNamespace () {
  return apps && apps['psxt'] && apps['psxt']['namespace'] ? apps['psxt']['namespace'] : ''
}

export function handleNamespace (val) {
  return val ? val.replace(/\/api\//g, `${getNamespace()}/api/`) : val
}



// WEBPACK FOOTER //
// ./src/utils/namespace.js